import { IApplicationData } from "./common";
export class VoiceMail implements IApplicationData {
  constructor() {
    this.name = "Record VoiceMail";
    this.maxDuration = "";
    this.audioId = "";
    this.audioPath = "";
    this.text = "";
    this.content = "";
    this.option = 1;
    this.attribute = "";
    this.sentiment = "";
    this.speechtotext = true;
    this.isRequired = true;
    this.checkFields = false;
    this.pathAttribute = "";
    this.timeout = "5";
    this.playBeep = true;
  }
  name: string;
  maxDuration: string;
  audioPath: string;
  audioId: string;
  text: string;
  content: string;
  option: number;
  attribute: string;
  timeout: string;
  sentiment: string;
  speechtotext: boolean;
  isRequired: boolean;
  checkFields: boolean;
  pathAttribute: string;
  playBeep: boolean;
}
